import type { MetaFunction } from '@remix-run/node';
import type { CreativeWork, ListItem } from 'schema-dts';
import type { loader as projectsLoader } from '~/routes/_app.projects.$';
import { getMetaBaseUrl } from '../util/create-meta-base-url';
import type { StaticParentLoaders } from '../util';

/** ItemList JSON-LD for project listing and category pages. */
export const createProjectsItemListSchema: MetaFunction<
    typeof projectsLoader,
    StaticParentLoaders
> = (props) => {
    if (!props.data?.projectTilesRocco?.length) {
        return [];
    }

    const { data, location } = props;
    const baseUrl = getMetaBaseUrl(props);

    const itemListElement: ListItem[] = data.projectTilesRocco.map(
        ({ model }, idx) => {
            const item: CreativeWork = {
                '@type': 'CreativeWork',
                '@id': baseUrl + model.link,
                name: model.title,
                url: baseUrl + model.link,
                image: model.images?.[0]?.src ?? '',
                creator: {
                    '@type': 'Organization',
                    name: model.professional.name,
                    url: baseUrl + model.professional.link,
                },
            };

            return {
                '@type': 'ListItem',
                position: (data.pagination?.currentRange?.from ?? 1) + idx,
                item,
            };
        },
    );

    return [
        {
            '@type': 'ItemList',
            url: baseUrl + location.pathname,
            numberOfItems: data.searchResult?.nbHits ?? itemListElement.length,
            itemListElement,
        },
    ];
};
